import { To } from "react-router";
import Routing from "../routing";
import DrawerItem from "./drawerItem";
import { DrawerVariant } from "./drawer";

export interface DrawerLinkProps extends Omit<
  React.HTMLAttributes<HTMLDivElement>,
  "title"
> {
  to: To;
  disablePrefix?: boolean;
  icon?: React.FC<any>;
  title: React.ReactNode;
  nested?: boolean;
  variantOverride?: DrawerVariant;
}

export default function DrawerLink(props: Readonly<DrawerLinkProps>) {
  const { className, to, disablePrefix, ...rest } = props;
  return (
    <Routing to={to} disablePrefix={disablePrefix} className="no-underline">
      {({ isActive }) => <DrawerItem {...rest} isActive={isActive} />}
    </Routing>
  );
}
